import React from 'react';
import './index.scss'

export default function Navbar() {
  return (
    <div className='navbar'>
      <div>menu</div>
      <div>Flirty Flowers</div>
      <div>cart</div>
    </div>
  )
}
